import { Box, Chip, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import Content from "../Components/Content";
import FilterButtonComp from "../Components/FilterButtonComp";
import DataCards from "../AdvisorNewDashBoard/DataCards";
import DisplayCurrentDateTime from "../Components/DisplayCurrentDateTime";
import UpcommingEvents from "../Components/UpcommingEvents";
import { useGetTokenOrLogout } from "../../../utils/token";
import OfflineOnlinePaymentPiechart from "./OfflineOnlinePaymentPiechart";
import NewCardcomp from "../../../components/card/NewCardcomp";
import LeadCalandar from "../../LeadConversation/LeadCalandar";
import PaymetBrekdown from "./PaymetBrekdown";
import RevenueCards from "../CenterAdminDashboard/NewRevenueCards";
import CustomPopup from "../../../components/CustomPopup";
import PaymentComp from "../popupComponent/PaymentComp";
import CustomSnackbar from "../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../../newTestPrep/newComponent/LoaderComp/Loader";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function AccountantdashBoardUi() {
  const userId = localStorage.getItem("userId");

  const getTokenOrLogout = useGetTokenOrLogout();
  const [selectedFilter, setSelectedFilter] = useState("currentmonth");
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [cartpaymentdata, setCartPaymentData] = useState([]);
  const [upcommigevent, setUpcommingEvent] = useState([]);
  const [upcommingLoading, setUpcommingLoding] = useState(false);
  const [isPieChartLoading, setIsPieChartLoading] = useState(false);
  const [pieChartData, setPieChartData] = useState({});
  const [chosenDate, setChosenDate] = useState(new Date());
  const [centerPaymentdata, setPaymentData] = useState([]);
  const [centerPaymentLoading, setCenterPaymentLoading] = useState([]);
  const [opendetailPopup, setOpenDetailPopup] = useState(false);
  const [selectedCardName, setSelectedCardName] = useState("");
  const [countryList, setCountryList] = useState([]);
  const [countryName, setCountryName] = useState(101);
  const [SelectedCardData, setSelectedCardData] = useState([]);
  const [selectedcardFilter, setSelectedcardfilter] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  // Fetch Countries
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}country`);
        if (response.ok) {
          const data = await response.json();
          const filteredCountry = data.filter(
            (i) => i.country_name === "India" || i.country_name === "Nepal"
          );
          setCountryList(filteredCountry);
        } else {
          console.log("server error");
          setCountryList([]);
        }
      } catch (error) {
        console.log("server error");
        setCountryList([]);
      }
    };

    fetchData();
  }, []);

  const handleCountryClick =(countryId)=>{
  setCountryName(countryId)

}

  const handleClickFilter = (criteria, cardFilter) => {
    setSelectedFilter(criteria);

    if (criteria !== "custom") {
      handleApplyRevenuFilter(criteria, null, null);
      getPaymentsForCenters(criteria, null, null);

      setFromDate(null);
      setToDate(null);
    }
    if (criteria === "custom" && fromDate !== null && toDate !== null) {
      handleApplyRevenuFilter(criteria, fromDate, toDate);
      getPaymentsForCenters(criteria, fromDate, toDate);
    }
  };

  // Fetch Card Data
  const handleApplyRevenuFilter = async (criteria, fromDate, toDate) => {
    setLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),

      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
      country_id:countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}accountantdashboard/chip-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        const result = await response.json();

        setCartPaymentData(result);

        setLoading(false);
      } else {
        console.log("Error");
        setLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      setLoading(false);
    }
  };

  const getPaymentsForCenters = (criteria, fromDate, toDate) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    setCenterPaymentLoading(true);

    const requestData = {
      user_id: userId,
      filter: criteria,
      to_date: toDate || null,
      from_date: fromDate || null,
country_id :countryName
    };

    fetch(`${API_ENDPOINT}accountantdashboard/online-offline-breakdown `, {
      method: "POST",
      headers,
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        setPaymentData(data);
        setCenterPaymentLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching daily data:", error);
        setCenterPaymentLoading(false);
      });
  };
  // Fetch Upcomming Event
  useEffect(() => {
    setUpcommingLoding(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/ongoing-upcomingevent/${userId}`,
          { headers }
        );
        if (response.ok) {
          const data = await response.json();
          setUpcommingEvent(data);
          setUpcommingLoding(false);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDateChange = (date) => {
    setChosenDate(date);
  };

  const getPieChartData = (date) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    setIsPieChartLoading(true);

    const requestData = {
      user_id: userId,
      date: date,
      country_id :countryName
    };

    fetch(`${API_ENDPOINT}accountantdashboard/donut-chart`, {
      method: "POST",
      headers,
      body: JSON.stringify(requestData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        setPieChartData(data);
        setIsPieChartLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching daily data:", error);
        setIsPieChartLoading(false);
      });
  };

  // render first time data
  useEffect(() => {
    if (selectedFilter !== "custom") {
      handleApplyRevenuFilter(selectedFilter);
      getPaymentsForCenters(selectedFilter);
    }
  }, [countryName]);

    useEffect(() => {
      if (selectedFilter === "custom") {
        handleApplyRevenuFilter(selectedFilter,fromDate,toDate);
        getPaymentsForCenters(selectedFilter,fromDate,toDate);
      }
    }, [countryName]);

  useEffect(() => {
    getPieChartData(chosenDate);
  }, [chosenDate,countryName]);

  // detailPopup
  const handleOpenDetailPopup = (cardName, cardFilter) => {
    console.log("clicked");
    setOpenDetailPopup(true);
    setSelectedCardName(cardName);
    setSelectedcardfilter(cardFilter);
  };

  const handleCloseDetailPopup = () => {
    setOpenDetailPopup(false);
  };

  const getCardMoreInfo = async (cardName, cardFilter) => {
    setDetailsLoading(true);
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    const requestData = {
      user_id: parseInt(userId),
      filter: selectedFilter,
      to_date: toDate,
      from_date: fromDate,
      filter_type: cardFilter,
        country_id:countryName
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}accountantdashboard/fetch-detailed-chip-data`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );
      const result = await response.json();
      if (response.ok) {
        setSelectedCardData(result);
        setDetailsLoading(false);
        handleOpenDetailPopup(cardName, cardFilter);
      } else if (response.status === 400) {
        showSnackbar(result.message, "error");
        setDetailsLoading(false);
      } else if (response.status === 401) {
        showSnackbar("Unknown User", "error");
        setDetailsLoading(false);
      } else if (response.status === 403) {
        showSnackbar("Unathorized User", "error");
        setDetailsLoading(false);
      } else {
        console.log("Error");
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch (error) {
      console.log(error, "Error");
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };
  return (
    <>
      <LoaderComp isLoading={detailsLoading} />
      <Grid container spacing={3}>
        {/* Left Side */}
        <Grid item xs={12} lg={9} sm={12} md={9}>
          <Grid container spacing={2}>
            {/* Greeting Content */}
            <Grid item xs={12}>
              <Content />{" "}
            </Grid>

            {/* Filter Button */}
            <Grid item xs={12} sm={12} md={9} mt={2}>
              <FilterButtonComp
                selectedFilter={selectedFilter}
                handleClickFilter={handleClickFilter}
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
              />
            </Grid>

             <Grid item xs={12} sm={12} md={3} mt={2} textAlign='end' container justifyContent='end' gap={1}>
              {countryList.map((country)=> (
             
       <Chip
       size="small"
  label={country?.country_name}
  onClick={() => handleCountryClick(country?.id)}

  style={{
    backgroundColor: country?.id === countryName ? "#00b13f" : "transparent",
    color: country?.id === countryName ? "#fff" : "#4b4b4b",
    borderColor: country?.id === countryName ? "#00b13f" : "#ccc",
    borderWidth: 1,
    borderStyle: 'solid',
    mx: 0.5,
    fontSize:"0.7rem"
  }}
/>

         
               ))}
             </Grid>

            {/* Cart Data */}
            <Grid item xs={12} container spacing={2} gap={1}>
              <Grid item xs={12} sm={3.5} lg={2.9}>
                <RevenueCards
                  backGround="#D5F6E1"
                  title="New Payments"
                  iconSrc="/Group 1000002878.png"
                  value={
                    loading ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      cartpaymentdata?.new_payment || 0
                    )
                  }
                  onClick={() => getCardMoreInfo("New Payments", "new_payment")}
                  countryId={countryName}
                />
              </Grid>

              <Grid item xs={12} sm={3.5} lg={2.9}>
                <RevenueCards
                  backGround="#E7F3FF"
                  title="Approved Payments"
                  iconSrc="/Group 1000002854.png"
                  value={
                    loading ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      cartpaymentdata?.approved_payment || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Approved Payments", "approved_payment")
                  }
                         countryId={countryName}
                />
              </Grid>

              <Grid item xs={12} sm={3.7} lg={2.9}>
                <RevenueCards
                  backGround="#FFEDFB"
                  title="Pending Payments"
                  iconSrc="/Group 1000002879.png"
                  value={
                    loading ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      cartpaymentdata?.pending_payment || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Pending Payments", "pending_payment")
                  }
                         countryId={countryName}
                />
              </Grid>

              <Grid item xs={12} sm={3.5} lg={2.9}>
                <RevenueCards
                  backGround="#FFF6E2"
                  title="Declined Payments"
                  iconSrc="/Group 1000002880.png"
                  value={
                    loading ? (
                      <CircularProgress size="1rem" />
                    ) : (
                      cartpaymentdata?.declined_payment || 0
                    )
                  }
                  onClick={() =>
                    getCardMoreInfo("Declined Payments", "declined_payment")
                  }
                         countryId={countryName}
                />
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <PaymetBrekdown
                centerPaymentLoading={centerPaymentLoading}
                centerPaymentdata={centerPaymentdata}
                countryId={countryName}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Right Side  */}

        <Grid item xs={12} lg={3} sm={12} md={3}>
          <Grid container spacing={2}>
            {/* Display Current Time */}
            <Grid item xs={12}>
              <DisplayCurrentDateTime />
            </Grid>

            {/* Display Upcoming Events */}
            <Grid item xs={12}>
              <UpcommingEvents
                data={upcommigevent}
                loading={upcommingLoading}
              />
            </Grid>

            {/* Payment Pichart */}
            <Grid item xs={12}>
              <NewCardcomp height="280px">
                <LeadCalandar onDateChange={handleDateChange} />
                {isPieChartLoading ? (
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    mt={2}
                  >
                    <CircularProgress />
                  </Box>
                ) : (
                  <OfflineOnlinePaymentPiechart
                    loading={isPieChartLoading}
                    pieChartData={pieChartData}
                      countryId={countryName}
                  />
                )}
              </NewCardcomp>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <CustomPopup
        open={opendetailPopup}
        onClose={handleCloseDetailPopup}
        component={
          <PaymentComp
            SelectedData={SelectedCardData}
            selectedFilter={selectedcardFilter}
            fromDate={fromDate}
            toDate={toDate}
            countryId={countryName}
          />
        }
        title={`${selectedCardName} Details`}
        maxWidth="lg"
        showDivider={true}
      />
      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </>
  );
}
